// Encode/decode simulation state into a compact base64 URL segment.
// Only stores start date + non-empty inputs.
export function encodeShare({ startYear, startMonth, inputs }) {
  const compact = {
    y: startYear,
    m: startMonth,
    i: inputs
      .map((row, idx) => {
        const dep = parseFloat(row.deposit);
        const wv = parseFloat(row.withdrawal_value);
        const hasDep = !isNaN(dep) && dep > 0;
        const hasW = !isNaN(wv) && wv > 0 && row.withdrawal_mode !== "none";
        if (!hasDep && !hasW && row.withdrawal_mode === "none") return null;
        return [
          idx,
          hasDep ? dep : 0,
          hasW ? wv : 0,
          row.withdrawal_type === "pct" ? 1 : 0,
          row.withdrawal_mode === "spot" ? 1 : row.withdrawal_mode === "continuous" ? 2 : 0,
        ];
      })
      .filter(Boolean),
  };
  const json = JSON.stringify(compact);
  // URL-safe base64
  return btoa(unescape(encodeURIComponent(json)))
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
}

export function decodeShare(str) {
  try {
    const b64 = str.replace(/-/g, "+").replace(/_/g, "/");
    const pad = "=".repeat((4 - (b64.length % 4)) % 4);
    const json = decodeURIComponent(escape(atob(b64 + pad)));
    const parsed = JSON.parse(json);
    const inputs = Array.from({ length: 120 }, () => ({
      deposit: "",
      withdrawal_value: "",
      withdrawal_type: "usd",
      withdrawal_mode: "none",
    }));
    (parsed.i || []).forEach(([idx, dep, wv, wt, wm]) => {
      inputs[idx] = {
        deposit: dep ? String(dep) : "",
        withdrawal_value: wv ? String(wv) : "",
        withdrawal_type: wt === 1 ? "pct" : "usd",
        withdrawal_mode: wm === 1 ? "spot" : wm === 2 ? "continuous" : "none",
      };
    });
    return { startYear: parsed.y, startMonth: parsed.m, inputs };
  } catch (e) {
    return null;
  }
}
